import axios from 'axios';
import { postData } from '../axiosUtils';

const userService = {
  /** Tenant-scoped: active tenant members only. */
  list: () => {
    return axios.get(`/api/user/list`).then((response) => response.data);
  },
  /** SaaS Identity directory: all users + groups / platform roles. */
  listPlatform: () => {
    return axios.get(`/api/user/listPlatform`).then((response) => response.data);
  },
  get: (id: any) => {
    return axios.get(`/api/user/details/${id}`).then((response) => response.data);
  },
  update: (entity: any) => {
    return postData({
      url: `/api/user/update`,
      data: entity,
      method: 'PUT',
    }).then((response) => response);
  },
  delete: (id: any) => {
    return postData({
      url: `/api/user/delete/${id}`,
      method: 'DELETE',
    }).then((response) => response);
  },
};

export default userService;
